import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { TranslocoModule } from '@jsverse/transloco';
import { LearnItemPart, Pages, TextPart } from '../../../types/player-types';

export interface PagesDialogData {
  pages: Pages[]
}

@Component({
  selector: 'pixl-pages-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    CdkDropList,
    CdkDrag,
    CdkDragHandle,
    TranslocoModule,
  ],
  templateUrl: './pages-dialog.component.html',
  styleUrl: './pages-dialog.component.scss',
})
export class PagesDialogComponent {
  private dialogRef = inject(MatDialogRef<PagesDialogComponent>);
  private data = inject<PagesDialogData>(MAT_DIALOG_DATA);

  public pages = signal<Pages[]>(this.data.pages.map(p => ({ ...p })));

  public drop(event: CdkDragDrop<Pages[]>): void {
    const arr = [...this.pages()];
    moveItemInArray(arr, event.previousIndex, event.currentIndex);
    this.pages.set(arr);
  }

  public confirm(): void {
    this.dialogRef.close(this.pages());
  }

  public cancel(): void {
    this.dialogRef.close(undefined);
  }

  public getPagePreview(page: Pages): string {
    const header = page.parts?.find((p: LearnItemPart) => (p as TextPart).name === 'header') as TextPart | undefined;
    const contentL = page.parts?.find((p: LearnItemPart) => (p as TextPart).name === 'content-l') as TextPart | undefined;
    const markup = header?.markup?.trim() || contentL?.markup?.trim() || '';
    // strip html tags and replace multiple spaces with a single space for better readability
    return markup.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }
}
